import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_API_TIMEOUT: z.string().transform(Number),
  VITE_ENABLE_MOCK_API: z
    .string()
    .transform((val) => val === 'true')
    .pipe(z.boolean()),
  VITE_ENABLE_ANALYTICS: z
    .string()
    .transform((val) => val === 'true')
    .pipe(z.boolean()),
  VITE_APP_NAME: z.string(),
  VITE_APP_VERSION: z.string(),
});


const parseEnv = () => {
  const parsed = envSchema.safeParse(import.meta.env);

  if (!parsed.success) {
    throw new Error('Invalid environment variables');
  }

  return parsed.data;
};

export const ENV = parseEnv();

export type Env = z.infer<typeof envSchema>;
